import { defer } from 'lodash-es';
import PageManager from 'navigation/page-manager/MainPageManager';
import MainPage from 'navigation/pages/MainPage';
import Component from 'navigation/component/Component';
import router from 'core/router';
import mqStore from 'store/mqStore';
import resize from 'helpers/resize';
import store from 'store';
import Panel from 'components/panel/Panel';
import Header from 'components/header/Header';
import scroll from 'core/scroll';
import Toaster from 'components/toaster/Toaster';
import GridHelper from 'components/grid-helper/GridHelper';
import Menu from 'components/menu/Menu';
import Overlay from 'components/overlay/Overlay';
import WebstoreSwitcher from 'components/webstore-switcher/WebstoreSwitcher';
import anime from 'animejs';
import { bindEmitterMethod } from 'helpers/bind';
import Notification from 'components/notification/Notification';
import sizeStore from 'store/sizeStore';
import Search from 'sections/search/Search';
import LoadingBar from 'components/loading-bar/LoadingBar';
import BlueshiftPopin from 'components/blueshift-popin/BlueshiftPopin';
import Popin from 'components/popin/Popin';
class App extends Component {
    pageTop = 0;
    loadingTl = anime.timeline();
    headerVariants = {
        solid: { className: 'header__solid' },
        transparent: { className: 'header__transparent' },
        dark: { className: 'header__dark' },
        light: { className: 'header__light' },
        'solid-fixed': { className: 'header__solid-fixed' },
        'only-logo': { className: 'header__only-logo' },
        'only-logo-returns': { className: 'header__only-logo-returns' }
    };
    constructor(el) {
        super(el);
        scroll.init();
        resize.setRoot(this.refs.container);
        resize.add(this);
        router.resolve();
    }
    initialized() {
        super.initialized();
        this.setInitialHeaderVariants();
    }
    getModulesMap() {
        return {
            panel: ['.panel', Panel],
            menu: ['.menu', Menu],
            blueshiftPopin: ['.blueshift-popin', BlueshiftPopin],
            search: ['.search', Search],
            popin: ['.popin', Popin],
            notification: ['.notification', Notification],
            header: ['.header', Header],
            toaster: ['.toaster', Toaster],
            gridHelper: ['.grid-helper', GridHelper],
            overlay: ['.overlay', Overlay],
            webstoreSwitcher: ['.webstore-switcher', WebstoreSwitcher],
            loadingBar: ['.loading-bar', LoadingBar]
        };
    }
    bindModules() {
        this.pageManager = new PageManager(this.refs.container, '.page', MainPage, {}, {
            crossTransition: false
        });
        super.bindModules();
        store.routers.get().main = this.pageManager;
        this.modules.pageManager = this.pageManager;
    }
    show = () => {
        this.invoke('show');
    };
    bindEvents(add) {
        resize.add(this);
        scroll.on(this.updateFixedTop);
        const emitterMethod = bindEmitterMethod(add);
        this.pageManager.once('show', this.show);
        if (this.modules.loadingBar) {
            this.pageManager[emitterMethod]('load:start', this.modules.loadingBar?.begin);
            this.pageManager[emitterMethod]('load:end', this.modules.loadingBar?.complete);
        }
        store.headerVariants.toggleListener(add, (variants) => this.updateHeaderVariants(variants));
        store.panel.toggleListener(add, (panel) => this.onPanelChange(panel));
        this.resize();
        this.updateFixedTop();
    }
    onPanelChange(panel) {
        if (panel)
            this.modules.toaster.hideAllMessages();
    }
    setInitialHeaderVariants() {
        const classes = Array.from(document.body.classList);
        const variants = classes.filter(c => c.includes('header__')).map(c => c.replace('header__', ''));
        store.headerVariants.set(variants);
    }
    updateHeaderVariants(variants) {
        Object.keys(this.headerVariants).forEach(key => {
            const variant = this.headerVariants[key];
            document.body.classList.toggle(variant.className, variants.includes(key));
        });
    }
    onLoading = (loading) => {
        document.documentElement.classList.toggle('loading', loading);
    };
    resize = () => {
        const { height, width, innerHeight } = resize.dimensions();
        if (!CSS.supports('width', '100dvh'))
            document.documentElement.style.setProperty('--vh', height + 'px');
        if (!CSS.supports('height', '100svh'))
            document.documentElement.style.setProperty('--ivh', innerHeight + 'px');
        document.documentElement.style.setProperty('--vw', width + 'px');
        defer(() => {
            super.resize();
            this.invoke('resize');
            this.updateFixedTop();
        });
    };
    updateFixedTop = () => {
        const fixedTop = Math.max(0, sizeStore.notificationHeight.get() - document.scrollingElement.scrollTop);
        const pageTop = fixedTop + sizeStore.headerHeight.get();
        if (pageTop === this.pageTop)
            return;
        this.pageTop = pageTop;
        document.documentElement.style.setProperty('--notification-height', sizeStore.notificationHeight.get() + 'px');
        document.documentElement.style.setProperty('--header-top', fixedTop + 'px');
        document.documentElement.style.setProperty('--page-top', (fixedTop + sizeStore.headerHeight.get()) + 'px');
    };
    updateSizes() {
        const { innerHeight, height } = resize.dimensions();
        if (mqStore && mqStore.tabletPortrait) {
            if (this.refs) {
                const { offsetTop } = this.refs ? this.refs.container : { offsetTop: 0 };
                document.documentElement.style.setProperty('--available-height', (height - offsetTop) + 'px');
                document.documentElement.style.setProperty('--available-inner-height', (innerHeight - offsetTop) + 'px');
                this.updateFixedTop();
            }
        }
    }
}
export default App;
